///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { GtthKeyValueDTO, ProductServiceDTO, ProductTypeEnum } from '../../generated/shared-types.model';

@Injectable()
export class ProductService {
    private readonly resourceUrl = 'api/product-services';

    constructor(private readonly http: HttpClient) {}

    public findOne(id: number): Observable<ProductServiceDTO> {
        return this.http.get<ProductServiceDTO>(`${this.resourceUrl}/${id}`).pipe(catchError(() => of(undefined)));
    }

    public removeObject(object: ProductServiceDTO): Observable<number> {
        return this.http.delete<number>(`${this.resourceUrl}/${object.id}`);
    }

    create(productService: ProductServiceDTO): Observable<ProductServiceDTO> {
        return this.http.post<ProductServiceDTO>(this.resourceUrl, productService).pipe(catchError(() => of(undefined)));
    }

    update(productService: ProductServiceDTO): Observable<ProductServiceDTO> {
        return this.http.put<ProductServiceDTO>(this.resourceUrl, productService).pipe(catchError(() => of(undefined)));
    }

    queryByType(type: ProductTypeEnum): Observable<ProductServiceDTO[]> {
        return this.http.get<ProductServiceDTO[]>(`${this.resourceUrl}/type/${type}`).pipe(catchError(() => of([])));
    }

    queryForProject(projectId: number): Observable<ProductServiceDTO[]> {
        return this.http.get<ProductServiceDTO[]>(`${this.resourceUrl}/project/${projectId}`).pipe(catchError(() => of([])));
    }

    getProductServicesTypes(): Observable<GtthKeyValueDTO[]> {
        return this.http.get<GtthKeyValueDTO[]>(`${this.resourceUrl}/types`).pipe(catchError(() => of([])));
    }
}
